import axios from 'axios'
import env from '../env'
import qs from 'qs'

const { BRANDID } = Config
/** 会员卡卡相关API */
export default class McApi {
  static async getCardList (params?: { cardIds?: number[] }) {
    const Url: string = `${env.MEMBER}/card`
    const filter = [
      `brandId||$eq||${BRANDID}`,
      'parentId||$isnull'
    ]
    if (params?.cardIds && params?.cardIds.length > 0) {
      filter.push(`cardId||$in||${params.cardIds.join(',')}`)
    }
    const res: any = await axios.get(Url, {
      params: {
        filter,
        sort: 'sysModifyTime,DESC',
        join: [
          'stores',
          'scales',
          'couponPolicys',
          'exts',
          'mallProducts',
          'products'
        ],
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
    })
    return res.error ? res : res.result
  }

  // 获取品牌下所有等级卡
  static async getBrandLevelCardList () {
    const Url: string = `${env.MEMBER}/card`
    const filter = [
      `brandId||$eq||${BRANDID}`,
      'parentId||$notnull'
    ]
    const res: any = await axios.get(Url, {
      params: {
        filter,
        sort: 'sysModifyTime,DESC',
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
    })
    return res.error ? res : res.result
  }

  // 所有会员卡包括主卡等级卡
  static async getAllLevelCardList (params?: { cardIds?: number[] }) {
    const Url: string = `${env.MEMBER}/card`
    const filter = [
      `brandId||$eq||${BRANDID}`
    ]
    if (params?.cardIds && params?.cardIds.length > 0) {
      filter.push(`cardId||$in||${params.cardIds.join(',')}`)
    }
    const res: any = await axios.get(Url, {
      params: {
        filter,
        join: [
          'stores',
          'scales',
          'couponPolicys',
          'exts',
          'mallProducts',
          'products'
        ],
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
    })
    return res.error ? res : res.result
  }

  static async getLevelCardList (parentId: number) {
    const Url: string = `${env.MEMBER}/card`
    const search: any[] = ['cardId', 'cardName', 'isLevel', 'levelGrowth', 'parentId', 'discountType', 'discountValue', 'mallDiscountType', 'mallDiscountValue', 'mallGrowth', 'mallGrowthGet', 'consumeGrowth', 'consumeGrowthGet', 'rechargeGrowth', 'rechargeGrowthGet', 'mallProducts', 'products']
    const s: any = {
      $and: [
        { brandId: BRANDID },
        {
          $or: [
            { cardId: parentId },
            { parentId: parentId }
          ]
        }
      ]
    }
    const res: any = await axios.get(Url, {
      params: {
        s: JSON.stringify(s),
        join: ['exts', 'recharges', 'couponPolicys', 'recharges.coupons']
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  };

  // 获取卡详情（含拼团数据）
  static async getCardDetails (cardId: number, groupBuyId: number) {
    const Url: string = `${env.MEMBER}/card/detail`
    const res: any = await axios.get(Url, {
      params: {
        cardId,
        groupBuyId
      }
    })
    return res.error ? res : res.result
  }
}
